import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Created by <b><a href="https://www.sportstf.com/" target="_blank">Soccer Talent Finder</a></b> 2021
    </span>
  `,
})
export class FooterComponent {
}
